import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { TaxGroupDto } from "../../../../dtos/catalogs/taxGroup/TaxGroupDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import TaxGroupDetailSkeleton from "./TaxGroupDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";

interface IProps {
  model: TaxGroupDto | null;
  modelUpdatedEvent: (newModel: TaxGroupDto) => void;
}

interface TaxGroupModel {
  id?: string;
  name: string;
}

export const TaxGroupDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<TaxGroupModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: TaxGroupModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: TaxGroupDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
  };

  if (!model) {
    return (
      <>
        <TaxGroupDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={3}>
              <NFLookupInput title={"ID"} fieldName={"id"} items={["test", "test", "test"]} />
            </Col>
            <Col sm={9}>
              <NFTextInput title={"Name"} fieldName={"name"} />
            </Col>
          </Row>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
